import { SolarRgbImageApi } from '../apis';
import { handleData } from './response.handler';
import { wrapAsyncWithCache, shallowCloneJsonLike } from '../utils/asyncResultCache';

/**
 * GET /api/solarRgbImages/{id} — 모달(loadRgbImage)·지도(DotSolarMapBox) 등 여러 경로에서 호출되므로
 * 서비스 단에서 한 번만 캐시/in-flight 공유한다.
 */
function fetchSolarRgbImage(rgbImageId) {
  return SolarRgbImageApi.getSolarRgbImage(rgbImageId).then(handleData);
}

const getSolarRgbImage = wrapAsyncWithCache(fetchSolarRgbImage, {
  cacheKey: (rgbImageId) =>
    rgbImageId != null && rgbImageId !== '' ? String(rgbImageId) : null,
  maxEntries: 24,
  cloneResult: shallowCloneJsonLike
});

export const SolarRgbImageService = {
  getSolarRgbImage
};


